import { Stack } from '@montugroup/design-system';
import { styled } from '@mui/material/styles';

export const StyledPrescription = styled(Stack)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  width: '100%',
  borderRadius: theme.spacing(2),
  marginLeft: 0,
  backgroundColor: theme.palette.common.white,
  overflow: 'hidden',

  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(2.5),
    gap: theme.spacing(4),
  },
}));
